/** Lấy `data` từ response axios sau khi gọi BaseService (hoặc cast an toàn). */
export function unwrapResponse(res) {
    return res.data;
}
